import { render, staticRenderFns } from "./FullscreenLoader.vue?vue&type=template&id=d38dbc1a"
import script from "./FullscreenLoader.vue?vue&type=script&lang=js"
export * from "./FullscreenLoader.vue?vue&type=script&lang=js"
import style0 from "./FullscreenLoader.vue?vue&type=style&index=0&id=d38dbc1a&lang=scss"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/var/www/dev.servis.leaseplan.cz/web/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('d38dbc1a')) {
      api.createRecord('d38dbc1a', component.options)
    } else {
      api.reload('d38dbc1a', component.options)
    }
    module.hot.accept("./FullscreenLoader.vue?vue&type=template&id=d38dbc1a", function () {
      api.rerender('d38dbc1a', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "resources/assets/js/components/global/FullscreenLoader.vue"
export default component.exports